import { useContext } from "react";
import {Container} from "react-bootstrap";
import styles from "../Footer.module.scss";
import AppConfigContext from "../../context/AppConfigContext";

const FormFooter = () => {
    const { config } = useContext(AppConfigContext);
    const { meta, copyright } = config.footer;
    return (
        <footer className={`py-3 ${styles.footer}`}>
            <Container>
                <p className="small mb-0 lh-base">{copyright}</p>
                {meta?.materialId && <span className="d-block small mt-1">{meta.materialId}</span>}
                {meta?.materialSubtext && <span className="d-block small mt-1">{meta.materialSubtext}</span>}
            </Container>
        </footer>
    )
}

export default FormFooter;
